import { createContext, FC, useContext, useState } from "react";

import { CaseContextProps } from "./types";
import { AuthContext } from "../authContext";
import { AddCaseSchema } from "src/validation/addCase";
import { UseFormReturn } from "react-hook-form";
import { AddCaseProps } from "src/pages/addCase/types";

export const CaseContext = createContext<CaseContextProps>({
  caseSchema: null,
  formControls: null,
  updateNewCaseControls: (formControls: UseFormReturn<AddCaseProps>) => {}
})



const CaseProvider: FC<{children: JSX.Element;}> = ({children}): JSX.Element => {
  const [formControls, updateFormControls] = useState<UseFormReturn<AddCaseProps> | null>(null)

  const { userData } = useContext(AuthContext)
  const validationSchema = AddCaseSchema(userData?.ref_type || "")

  const updateNewCaseControls = (formControls: UseFormReturn<AddCaseProps>): void => {
    updateFormControls(formControls)
  }


  return (
    <CaseContext.Provider 
      value={{
        caseSchema: validationSchema,
        formControls, updateNewCaseControls
      }}
    >
      {children}
    </CaseContext.Provider>
  )
}

export default CaseProvider
